import { OptionRenderers } from 'UI/utils/renderers';

const normalizeRecruiterOption = recruiter => {
  if (!recruiter?.id) return null;

  return {
    id: recruiter.id,
    fullName: recruiter?.personalInformation?.full_name,
    email: recruiter?.email || recruiter?.work_email || null
  };
};

export const getDefaultCandidateRecruiter = candidateData => {
  return normalizeRecruiterOption(candidateData?.recruiter);
};

export const getCandidateRecruitersOptions = candidateData => {
  if (!candidateData?.additionalRecruiters?.length) return [];

  const formattedAccountable = getDefaultCandidateRecruiter(candidateData);
  const accountableRecruiterId = formattedAccountable?.id;

  const formattedAdditionalRecruiters = candidateData.additionalRecruiters
    .map(item => normalizeRecruiterOption(item.recruiter))
    .filter(Boolean)
    .filter(item => item.id !== accountableRecruiterId);

  return formattedAccountable
    ? [formattedAccountable, ...formattedAdditionalRecruiters]
    : formattedAdditionalRecruiters;
};

export const normalizeCandidateSearchOption = candidateOption => {
  if (!candidateOption) return candidateOption;

  return {
    ...candidateOption,
    fullName: candidateOption.fullName || candidateOption.title || '',
    personalEmail: candidateOption.personalEmail || candidateOption.personal_email || null,
    company: candidateOption.company || candidateOption.current_company || null
  };
};

export const getCandidateSearchOptionLabel = candidateOption =>
  candidateOption?.fullName || candidateOption?.title || '';

export const renderCandidateSearchOption = candidateOption => {
  const renderPerson = OptionRenderers.globalSearchPerson('fullName');
  const normalizedOption = normalizeCandidateSearchOption(candidateOption);

  return renderPerson(normalizedOption);
};
